/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageLocation
 */
export interface StorageLocation {
    /**
     * Name oder Bezeichner des Lagerplatzes
     * @type {string}
     * @memberof StorageLocation
     */
    location: string;
    /**
     * Menge am Lagerplatz
     * @type {number}
     * @memberof StorageLocation
     */
    quantity: number;
    /**
     * Gibt an, ob dies der primäre Lagerplatz ist
     * @type {boolean}
     * @memberof StorageLocation
     */
    isPrimary: boolean;
    /**
     * Entfernung zum Lagerplatz in Metern
     * @type {number}
     * @memberof StorageLocation
     */
    distance?: number;
}

/**
 * Check if a given object implements the StorageLocation interface.
 */
export function instanceOfStorageLocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "location" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "isPrimary" in value;

    return isInstance;
}

export function StorageLocationFromJSON(json: any): StorageLocation {
    return StorageLocationFromJSONTyped(json, false);
}

export function StorageLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'location': json['location'],
        'quantity': json['quantity'],
        'isPrimary': json['isPrimary'],
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
    };
}

export function StorageLocationToJSON(value?: StorageLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'location': value.location,
        'quantity': value.quantity,
        'isPrimary': value.isPrimary,
        'distance': value.distance,
    };
}

